import { message } from 'antd'
import useFetch from 'elements/Hooks/useFetch'
import { get, isEmpty } from 'lodash'
import React from 'react'
import { withRouter } from 'react-router-dom'
import { OrdersApi } from '../../../api/Purchase/Orders'
import { VendorQuoteApi } from '../../../api/Purchase/VendorQuotes'
import OrderModal from '../../../components/Purchasing/Order/OrderModal'
import ReadyToOrder from '../../../components/Purchasing/Order/ReadyToOrder'
import ReadyToOrderList from '../../../components/Purchasing/Order/ReadyToOrderList'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'
import useModalData from '../../../elements/Hooks/useModalData'
import useSelectionTable from '../../../elements/Hooks/useSelectionTable'
import useSubmit from '../../../elements/Hooks/useSubmit'
import useTitle from '../../../elements/Hooks/useTitle'

function ReadyToOrderCont(props) {
  const { requisitionID } = props
  useTitle('Ready To Order')

  const { data, fetching, fetch } = useFetch({
    url: `/orders/purchaseList${requisitionID ? `?reqs=${requisitionID}` : ''}`,
    queryKey: 'requisitions',
  })

  const { list, company, onChangeCompany } = useListCompanyFilter(data, fetching)

  const select =
    '_id,_key,code,vendor,vendorRep,title,orderType,date,validityEnd,company,currency,subTotal,status,paymentStatus'
  const { data: OrdersList, fetching: fetchingOrders, fetch: fetchOrders } = useFetch({
    url: `orders/?select=${select}`,
    queryKey: 'orders',
  })

  const [completing, completeFunc] = useSubmit(OrdersApi.completeReqLine)

  async function complete() {
    await completeFunc(selection)
    await fetch()
  }

  const cachedListOrders = OrdersList.filter((o) => o.category !== 'Freight' && o.type !== 'Freight Booking')

  const { list: listOrders, company: companyOrder, onChangeCompany: onChangeCompanyOrder } = useListCompanyFilter(
    cachedListOrders,
    fetchingOrders
  )

  const {
    visible,
    modalType,
    object: order,
    submitting,
    checkForm,
    update,
    remove,
    removing,
    formRef,
    onShow,
    onCancel,
    setSubmitting,
    isNew,
  } = useModalData(undefined, OrdersApi.update, OrdersApi.remove, fetch)

  const { tableRef, selection, selectAll, setSelection, toggleSelection, toggleAll, isSelected } = useSelectionTable()

  async function submit() {
    let newObject = await checkForm()
    newObject.reqs = selectionData
    setSubmitting(true)
    try {
      await OrdersApi.create(newObject)
      onCancel()
      fetch()
      fetchOrders()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  const selectionData = selection.map((s) => list.find((p) => get(p, '_id') === s))
  const selectionIDs = selectionData.map((s) => get(s, 'reqs.code'))
  const filteredData = isEmpty(selectionIDs)
    ? list
    : list.filter((v) => {
        const sameCurrency = get(v, 'currency') === get(selectionData, '[0]currency')
        const sameCategory = get(v, 'category') === get(selectionData, '[0]category')
        const sameType = get(v, 'type') === get(selectionData, '[0]type')
        const sameCenter = get(v, 'budgetLine.centers._id') === get(selectionData, '[0]budgetLine.centers._id')

        const sameVendor = get(v, 'vendor._id') === get(selectionData, '[0]vendor._id') || isEmpty(get(v, 'vendor._id'))

        return sameCurrency && sameCategory && sameType && sameCenter && sameVendor
      })

  const vendorQuoteId =
    get(
      selectionData.find((r) => !!get(r, 'vendorQuote')),
      'vendorQuote._id'
    ) || ''

  const { list: VendorQuote, fetching: fetchingVendorQuote, fetch: fetchVendorQuote } = useFetchList(
    () => VendorQuoteApi.read(vendorQuoteId.replace('spquotes/', '')),
    [vendorQuoteId],
    isEmpty(vendorQuoteId)
  )

  const vendorQuoteLineId = get(selectionData, '[0].vendorQuoteLine._id') || ''
  const { list: VendorQuoteLine, fetching: fetchingVendorQuoteLine, fetch: fetchVendorQuoteLine } = useFetchList(
    () => VendorQuoteApi.lines.read(vendorQuoteLineId.replace('spquotesLines/', '')),
    [vendorQuoteLineId],
    isEmpty(vendorQuoteLineId)
  )

  const { data: centers } = useFetch({
    url: `centers?select=_id,name,_parent`,
    queryKey: 'centers',
  })

  const passProps = {
    list,
    fetching,
    fetch,
    visible,
    modalType,
    order,
    submitting,
    update,
    remove,
    removing,
    formRef,
    submit,
    centers,
    onShow,
    onCancel,
    tableRef,
    selection,
    selectAll,
    setSelection,
    toggleSelection,
    toggleAll,
    isSelected,
    selectionData,
    selectionIDs,
    filteredData,
    isNew,
    listOrders,
    fetchingOrders,
    fetchOrders,
    company,
    onChangeCompany,
    companyOrder,
    onChangeCompanyOrder,
    VendorQuote,
    fetchingVendorQuote,
    fetchVendorQuote,
    VendorQuoteLine,
    fetchingVendorQuoteLine,
    fetchVendorQuoteLine,
    completing,
    complete,
  }

  return requisitionID ? (
    <>
      <OrderModal {...passProps} />
      <ReadyToOrderList {...passProps} />
    </>
  ) : (
    <ReadyToOrder {...passProps} />
  )
}

ReadyToOrderCont.propTypes = {}
ReadyToOrderCont.defaultProps = {}

export default withRouter(ReadyToOrderCont)
